class StickyEngine extends HTMLElement {
  constructor() {
    super()
    this.padding = parseInt(this.dataset.padding)
    this.stickyTopPart = document.getElementById("grid-archive-header")

    this.headerEl = document.getElementById("nav-wrapper")
    this.headerType = document.querySelector("main-nav").dataset.uxPosition
    this.headerHeight = this.headerEl.offsetHeight

    this.updateDistance = this.updateDistance.bind(this)
  }

  connectedCallback() {
    this.lastScroll = window.scrollY

    window.addEventListener("scroll", this.updateDistance)
  }

  updateDistance() {
    if (window.matchMedia("screen and (min-width: 1024px)").matches) {
      let topDistance = 0

      if (this.stickyTopPart) {
        topDistance = this.stickyTopPart.clientHeight

        if (this.headerType === "fixed") {
          topDistance += this.headerHeight
        }
      } else if (this.headerType === "hide") {
        topDistance = -this.headerEl.props.navMargin + this.headerHeight
      } else if (this.headerType === "fixed") {
        topDistance = this.headerHeight
      }

      const topSpaceToAlignToTop = topDistance + this.padding // ideal top spacing

      if (this.scrollHeight < window.innerHeight - topSpaceToAlignToTop) {
        // sticky element is smaller than window height
        this.style.top = topSpaceToAlignToTop + "px"
      } else {
        const scrollProgress = window.scrollY - this.lastScroll // scroll progrss from the last check
        const newTopDistance = -scrollProgress + (parseInt(this.style.top) || 0)

        if (scrollProgress > 0) {
          // scrolling down
          const topSpaceToAlignToBottom = window.innerHeight - this.scrollHeight - this.padding // ideal top spacing

          if (topSpaceToAlignToBottom !== parseInt(this.style.top)) {
            if (topSpaceToAlignToBottom <= newTopDistance) {
              this.style.top = newTopDistance + "px"
            } else {
              if (newTopDistance + scrollProgress > topSpaceToAlignToBottom)
                this.style.top = topSpaceToAlignToBottom + "px"
            }
          }
        } else {
          // scrolling up
          this.style.top = Math.min(newTopDistance, topSpaceToAlignToTop) + "px"
        }
      }

      this.lastScroll = this.scrollPosition
    }
  }

  get scrollPosition() {
    return Math.max(0, Math.min(window.scrollY, document.body.offsetHeight - window.innerHeight))
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.updateDistance)
  }
}

if (!window.customElements.get("sticky-engine")) {
  window.customElements.define("sticky-engine", StickyEngine)
}
